import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiResponse } from "types/ApiResponse";
import { BillingDetailsData } from "types/payment.invoicing.api";
import { getBillingDetails, manageBillingDetails } from "./thunk";

type RequestStatus = "idle" | "loading" | "succeeded" | "failed";

interface ItemStatus {
  fetch: RequestStatus;
  manage: RequestStatus;
}

interface ItemErrors {
  fetch: string | null;
  manage: string | null;
}

export interface CategoryState {
  billingData: BillingDetailsData | null;
  status: ItemStatus;
  errors: ItemErrors;
}

export const initialState: CategoryState = {
  billingData: null,

  status: {
    fetch: "idle",
    manage: "idle",
  },
  errors: {
    fetch: null,
    manage: null,
  },
};

const paymantsInvoicingSlice = createSlice({
  name: "paymantsInvoicing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get Categories
    builder.addCase(getBillingDetails.pending, (state) => {
      state.status.fetch = "loading";
      state.errors.fetch = null;
    });
    builder.addCase(
      getBillingDetails.fulfilled,
      (state, action: PayloadAction<ApiResponse<BillingDetailsData>>) => {
        console.log(action);
        state.status.fetch = "succeeded";
        state.billingData = action.payload.payload;
      }
    );
    builder.addCase(getBillingDetails.rejected, (state, action) => {
      state.status.fetch = "failed";
      state.errors.fetch = action.payload || null;
    });

    builder.addCase(manageBillingDetails.pending, (state) => {
      state.status.manage = "loading";
      state.errors.manage = null;
    });
    builder.addCase(
      manageBillingDetails.fulfilled,
      (state, action: PayloadAction<ApiResponse<BillingDetailsData>>) => {
        state.status.manage = "succeeded";
        state.billingData = action.payload.payload;
      }
    );
    builder.addCase(manageBillingDetails.rejected, (state, action) => {
      state.status.manage = "failed";
      state.errors.manage = action.payload || null;
    });
  },
});

export default paymantsInvoicingSlice.reducer;

export const selectPaymantsInvoicingState = (state: any) =>
  state.paymantsInvoicing as typeof initialState;
